import type { NavigationItem, Role } from '../shared/types/domain';

export const roleMeta: Record<Role, { label: string; basePath: string; eyebrow: string }> = {
  member: { label: '会员端', basePath: '/member', eyebrow: '我的课程与成长' },
  employee: { label: '员工端', basePath: '/employee', eyebrow: '今日工作与会员服务' },
  manager: { label: '店长端', basePath: '/manager', eyebrow: '门店经营与异常闭环' },
  super: { label: '超管端', basePath: '/super', eyebrow: '总部治理与四店经营' },
};

export const roleNavigation: Record<Role, NavigationItem[]> = {
  member: [
    { label: '首页', path: 'home', description: '今日课程、课时、反馈与提醒' },
    { label: '课程', path: 'courses', description: '课程包、预约、签到与课消记录' },
    { label: '成长', path: 'growth', description: '教学反馈、评分与成长素材' },
    { label: '消费', path: 'spending', description: '订单、实收与退款状态' },
    { label: '我的', path: 'profile', description: '资料、门店、教练与账号安全' },
  ],
  employee: [
    { label: '工作台', path: 'workbench', description: '今日课表、待反馈、风险与通知' },
    { label: '教学', path: 'teaching', description: '排课、签到、课消、撤销与反馈' },
    { label: '客户', path: 'members', description: '客资跟进、会员预警、课包与订单' },
    { label: '成长', path: 'star-energy', description: '排班培训、星能、排行与AI建议' },
    { label: '我的', path: 'profile', description: '工作数据、通知、手册与账号' },
  ],
  manager: [
    { label: '门店看板', path: 'dashboard', description: '教学、销售、评分、星能与风险' },
    { label: '教学', path: 'teaching', description: '店长本人排课、签到、扣课、反馈与成长影像' },
    { label: '待办', path: 'tasks', description: '订单例外、退款、撤销与低评分' },
    { label: '人员', path: 'people', description: '本店员工、状态、交接与数据' },
    { label: '会员', path: 'members', description: '本店会员、课程、订单与风险' },
    { label: '运营中心', path: 'management', description: 'CRM、日结、异常、排班、营销与AI' },
  ],
  super: [
    { label: '总部看板', path: 'dashboard', description: '四店经营、目标与风险对比' },
    { label: '组织', path: 'organization', description: '门店、人员、账号与权限' },
    { label: '运营中心', path: 'business', description: '四店CRM、日结、异常、人才与营销归因' },
    { label: '激励中心', path: 'incentives', description: '星能、荣誉、清零与商城' },
    { label: '系统中心', path: 'system', description: '公告、导出、审计、参数与备份' },
  ],
};
